import styled from 'styled-components'
import { COLORS } from 'tokens'

export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  gap: 24px;
  background: ${COLORS.background};
`
